import examples from '../data/article-examples';
import { ENDPOINTS } from './ContentApiConstants';

const DEBUG = true;

export async function localFetch({ endpoint, fetchUrl, fetchParameters, parameters }) {
    if (DEBUG) console.log(`localContentFetch :: ${fetchParameters.method} :: ${fetchUrl} :: ${parameters}`);
    switch (endpoint) {
        case ENDPOINTS.getSearches:
            await new Promise(resolve => {
                setTimeout(resolve, 2000)
            });

            let dummyResult = {
                id: "1",
                filters: [{
                    key: "brand",
                    value: ["Lehti A"]
                }],
                timestamp: "2025-04-10T09:52:59.048113",
                query: examples.searchResult.chat_session.chat_messages[0].message_content,
                chat_session: examples.searchResult.chat_session
            };

            if (!parameters || !parameters.id) {
                dummyResult = [dummyResult];
            }

            return new Response(JSON.stringify(
                dummyResult
            ), {
                status: 200,
                headers: { "Content-Type": "application/json" }
            });

        case ENDPOINTS.getSearchResults:
            await new Promise(resolve => setTimeout(resolve, 2000));

            return new Response(JSON.stringify({
                "result_count": examples.searchResult.articles.length,
                "page": parameters.page,
                "limit": parameters.limit,
                "results": [...examples.searchResult.articles].splice(
                    (parameters.page - 1) * parameters.limit, parameters.limit)
            }), {
                status: 200,
                headers: { "Content-Type": "application/json" }
            });
        case ENDPOINTS.postSearches:
            await new Promise(resolve => setTimeout(resolve, 2000));

            return new Response(JSON.stringify({
                id: "1",
                chat_session: examples.searchResult.chat_session
            }), {
                status: 200,
                headers: { "Content-Type": "application/json" }
            });
        default:
            throw new Error(`localContentFetch :: Unknown endpoint: ${endpoint}`);
    }
}